// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layouts-default-body-byfln{min-width:1240px}.layouts-default-body-byfln a:hover{color:var(--color-primary-hover)}.layouts-default-layout-bkvmr{display:flex;flex-direction:column;min-height:100vh}.layouts-default-nuxt-bnjtg{flex-grow:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": "layouts-default-body-byfln",
	"layout": "layouts-default-layout-bkvmr",
	"nuxt": "layouts-default-nuxt-bnjtg"
};
module.exports = ___CSS_LOADER_EXPORT___;
